import { AppRouteProps } from "@harea/component";
import React from "react";

const CreateDocumentContainer = React.lazy(
    () => import("./container/CreateDocumentContainer")
);
export const createDocumentRoutes: Array<AppRouteProps> = [
    {
        title: "Harea.Document.Template.Create",
        element: <CreateDocumentContainer />,
        path: "create",
        roles: ["DOCUMENT_MANAGE", "DOCUMENT_TEMPLATE", ""]
    },
];
